import { useState } from "react";

import UploadVehicles from "./components/UploadVehicles";
import Matched from "./components/Matched";
import Pending from "./components/Pending";
import Completed from "./components/Completed";

export default function Home() {
  const [uploadModal, setUploadModal] = useState<boolean>(false);

  return (
    <div className="bg-gray-100">
      <div className="m-1 max-w-7xl mx-auto">
        <UploadVehicles isVisible={uploadModal} setVisible={setUploadModal} />
        <div className="grid grid-cols-12 gap-1">
          <div className="col-span-12 sm:col-span-4">
            <Matched />
          </div>
          <div className="col-span-12 sm:col-span-4">
            <Pending />
          </div>
          <div className="col-span-12 sm:col-span-4">
            <Completed />
            <div />
          </div>
        </div>
      </div>
    </div>
  );
}
